import queryString from 'query-string';

const getHost = (serverContext) => {
  const {
    Urls: { CampaignAzureDomain },
  } = serverContext;

  return CampaignAzureDomain || window.location.origin;
};

export const getUrlForPath = (serverContext, path, optionalSearch = {}) => {
  const {
    CurrentCustomer,
    CurrentAccount,
    CurrentUser,
  } = serverContext;
  const host = getHost(serverContext);
  const search = {
    cid: CurrentCustomer.Id,
    aid: CurrentAccount.Id,
    uid: CurrentUser.Id,
    ...optionalSearch,
  };
  const searchString = queryString.stringify(search);

  return `${host}/${path}?${searchString}`;
};

export const getCampaignUrl = serverContext => getUrlForPath(serverContext, 'campaign/vnext');

export const getCampaignPageUrl = (serverContext, page, optionalSearch) => getUrlForPath(serverContext, `campaign/vnext/${page}`, optionalSearch);

export const getSingleCampaignUrl =
  (serverContext, campaignId) => `${getUrlForPath(serverContext, 'campaign/smart')}#/campaign/${campaignId}`;

export const URL_VALIDATION_PATTERN = /^(^[^ ,"']+)\.([^ ,"']+)$/i;

export const getExpertSignupUrl =
  (serverContext, fromGoogleImport, isExpertStandaloneApp) => {
    const {
      Urls: { ExpertSignupUrl },
    } = serverContext;
    let redirectSource = null;

    if (isExpertStandaloneApp) {
      redirectSource = fromGoogleImport ? 'nesgi' : 'nes';
    } else {
      redirectSource = fromGoogleImport ? 'scgi' : 'sc';
    }
    return `${ExpertSignupUrl}&redirectSource=${redirectSource}`;
  };
